import React from 'react';
import './BioPage.css';
import bioPic from '../../assets/images/bio_pic.jpg'; // 1. Import the image

function BioPage() {
  return (
    <div className="bio-page">
      <div className="bio-image-container">
        <img src={bioPic} alt="Evan Reid playing the saxophone" className="bio-pic" />
        <p className="image-caption">
          "Performing with these talented musicians has inspired me to focus on what I truly enjoy doing, playing music."
        </p>
      </div>
      <div className="bio-content">
        <span className="eyebrow">The Artist</span>
        <h2>Bio</h2>
        <div className="bio-rule"></div>
        <p>
        Evan started playing the saxophone when he was just 16. He was tutored by his father, an accomplished musician, then went on to graduate from the NZ  Royal School of Music. Evan has been playing the saxophone for over 30 years and is equally experienced on guitar and vocals.
        </p>
        <p>
        Evan shares the distinction of excellence as both a successful musician and a sought after music teacher. During the nineties and first half of this decade, Evan performed at various jazz festivals and gigs as a member of the duo ‘Easy Vibes’. His recent live engagements  have included work with some of NZ and the USA's top musicians.
        </p>
        <p>
        He has played at many social functions and is well known around Auckland as a street entertainer. Evan plays at street events, markets and shopping malls as a solo performer raising funds for Starship Children's Hospital.
        </p>
        {/* You can continue adding more paragraphs as needed */}
      </div>
    </div>
  );
}

export default BioPage;